import environment from "@gtmhub/env/module";
import { InsightboardService } from "@gtmhub/insightboards/services/dashboardService";
import { InsightService } from "./services/insightService";
import { DataSourceService } from "@gtmhub/datasources/services/dataSourceService";
import insightSelector from "./components/insight-selector/module";
import { InsightTemplateSuggestionsService } from "@gtmhub/insightboards/services/insight-template-suggestions.service";
import { EntityService } from "@gtmhub/entities/services/EntityService";
import { SectionHeaderService } from "@gtmhub/insightboards/services/sectionHeaderService";

const mod = angular.module("insights-core", [environment, insightSelector]);

mod.service("InsightboardService", InsightboardService);
mod.service("SectionHeaderService", SectionHeaderService);
mod.service("InsightService", InsightService);
mod.service("DataSourceService", DataSourceService);
mod.service("InsightTemplateSuggestionsService", InsightTemplateSuggestionsService);
mod.service("EntityService", EntityService);

mod.filter("getDataSourceBlueprintLogo", () => (logoUrl: string, dataSourceName: string, ext: "png" | "jpeg") => logoUrl || `/dist/img/logos/${dataSourceName}.${ext}`);

mod.filter("highlight", function () {
  return function (text: string, phrase: string) {
    return phrase ? text.replace(new RegExp("(" + phrase + ")", "gi"), "<kbd class='highlighted'>$1</kbd>") : text;
  };
});

export default mod.name;
